// extracted by mini-css-extract-plugin
export default {"iconBtn":"styles_iconBtn__skmqL","dialogButton":"styles_dialogButton__17dnx"};